import { useState, useEffect } from 'react'

function formatTime(time: any) {
  if (isNaN(time)) {
    return '00:00'
  }
  const date = new Date(time * 1000)
  const hours = date.getUTCHours()
  const minutes = date.getUTCMinutes()
  const seconds = date
    .getUTCSeconds()
    .toString()
    .padStart(2, '0')
  if (hours) {
    return `${hours}:${minutes.toString().padStart(2, '0')} `
  } else return `${minutes}:${seconds}`
}

const getVideoId = (url: string | undefined): string | undefined => {
  const match = url?.match(
    /(?:youtube\.com.*(?:\?v=|\/embed\/)|youtu.be\/)(.{11})/
  )
  return match?.[1]
}

const useVideoThumbnail = (
  contentCardSocialUrl: string,
  thumbnailUrl: string,
  contentCardThumbnailUrl: string,
  socialMediaUrl?: string
) => {
  const video_id =
    getVideoId(socialMediaUrl) || getVideoId(contentCardSocialUrl)

  const [socialThumbnailUrl, setSocialThumbnailUrl] = useState(
    `http://img.youtube.com/vi/${video_id}/maxresdefault.jpg`
  )

  useEffect(() => {
    const img = new Image()
    img.src = socialThumbnailUrl
    img.onload = function() {
      if (img.naturalWidth === 120 && img.naturalHeight === 90) {
        setSocialThumbnailUrl(
          thumbnailUrl
            ? thumbnailUrl
            : contentCardThumbnailUrl
            ? contentCardThumbnailUrl
            : ''
        )
      }
    }
  }, [socialThumbnailUrl, video_id, contentCardThumbnailUrl])

  return socialThumbnailUrl
}

export { useVideoThumbnail, formatTime }
